import { render } from "./correction.vue?vue&type=template&id=89137cb2"
import script from "./correction.vue?vue&type=script&lang=js"
export * from "./correction.vue?vue&type=script&lang=js"
script.render = render

export default script